export default "__VITE_PUBLIC_ASSET__522f9166__"